import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { Router } from '@angular/router';

export interface IList {
  header: string;
  action?: string;
  menu?: IMenu[];
}

interface IMenu {
  icon: string
  name: string;
  action: string;
}

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrl: './list.component.scss',
    standalone: false
})
export class ListComponent implements OnInit {

  @Input() list: IList[] = [];
  @Output() listClick = new EventEmitter<string>();

  constructor(
    private router: Router,
    public layoutService: LayoutService,
  ) {}
  
  ngOnInit() {
    console.log('url', this.router.url.split('?')[0]);
    this.layoutService.selectedAction = this.router.url.split('?')[0];
    
    console.log('selectedAction', this.layoutService.selectedAction);
  }

  public clickList(event: MouseEvent | TouchEvent, action: string) {
    event.stopPropagation();
    this.listClick.emit(action);
    console.log('clickList', action);
    this.layoutService.selectedAction = action;
  }
}
